import { render } from "./TheWorkEventsPage.vue?vue&type=template&id=7c2f5e98"
import script from "./TheWorkEventsPage.vue?vue&type=script&lang=js"
export * from "./TheWorkEventsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__